module.exports = __webpack_public_path__ + "img/example_5.97af2503.png";